import { ComponentStyleConfig } from '@chakra-ui/react';
import { StyleFunctionProps } from '@chakra-ui/theme-tools';

const colorMap: Record<string, string> = {
  black: 'black.base',
  grey: 'grey.base',
  silver: 'silver.base',
  blue: 'blue.base',
  green: 'green.base',
  red: 'red.base',
  gold: 'gold.base',
  default: 'blue.base'
};

const IndicatorTheme: ComponentStyleConfig = {
  baseStyle: (props: StyleFunctionProps) => ({
    background: colorMap[props.color] || colorMap.default
  }),
  sizes: {
    md: {
      width: '8px',
      height: '8px'
    },
    lg: {
      w: '12px',
      h: '12px'
    }
  }
};

export default IndicatorTheme;
